(() => {
  'use strict';

  const config = document.querySelector('script[data-lounelle-market-carrier]');
  if (!config) return;

  const country = String(config.dataset.country || 'FR').toUpperCase();

  const carriers = {
    colissimo: {
      name: 'Colissimo',
      logo: config.dataset.logoColissimo
    },

    usps: {
      name: 'USPS',
      logo: config.dataset.logoUsps
    },

    'canada-post': {
      name: 'Canada Post',
      logo: config.dataset.logoCanadaPost
    },

    'royal-mail': {
      name: 'Royal Mail',
      logo: config.dataset.logoRoyalMail
    },

    'australia-post': {
      name: 'Australia Post',
      logo: config.dataset.logoAustraliaPost
    },

    'nz-post': {
      name: 'NZ Post',
      logo: config.dataset.logoNzPost
    },

    dhl: {
      name: 'DHL',
      logo: config.dataset.logoDhl
    },

    correos: {
      name: 'Correos',
      logo: config.dataset.logoCorreos
    },

    ctt: {
      name: 'CTT',
      logo: config.dataset.logoCtt
    },

    'poste-italiane': {
      name: 'Poste Italiane',
      logo: config.dataset.logoPosteItaliane
    },

    'austrian-post': {
      name: 'Österreichische Post',
      logo: config.dataset.logoAustrianPost
    },

    bpost: {
      name: 'bpost',
      logo: config.dataset.logoBpost
    },

    postnl: {
      name: 'PostNL',
      logo: config.dataset.logoPostnl
    },

    'an-post': {
      name: 'An Post',
      logo: config.dataset.logoAnPost
    },

    postnord: {
      name: 'PostNord',
      logo: config.dataset.logoPostnord
    },

    posten: {
      name: 'Posten',
      logo: config.dataset.logoPosten
    },

    dpd: {
      name: 'DPD',
      logo: config.dataset.logoDpd
    }
  };

const carrierByCountry = {
  FR: 'colissimo',
  US: 'usps',
  CA: 'canada-post',
  GB: 'royal-mail',
  AU: 'australia-post',
  NZ: 'nz-post',
  DE: 'dhl',
  ES: 'correos',
  PT: 'ctt',
  IT: 'poste-italiane',
  AT: 'austrian-post',
  BE: 'bpost',
  NL: 'postnl',
  IE: 'an-post',
  SE: 'postnord',
  DK: 'postnord',
  NO: 'posten'
};

  const key = carrierByCountry[country] || 'dpd';
  const carrier = carriers[key];

  if (!carrier || !carrier.name || !carrier.logo) return;

  const makeImage = (className) => {
    const image = document.createElement('img');

    image.src = carrier.logo;
    image.alt = carrier.name;
    image.decoding = 'async';
    image.className = className;

    return image;
  };

  const apply = () => {
    document.querySelectorAll('.product__icon__row').forEach((row) => {
      if (row.dataset.lounelleMarketCarrier === key) return;

      const text = row.querySelector('.product__icon__text');
      const currentImage = row.querySelector('img');

      const currentText = text ? text.textContent : '';
      const currentSrc = currentImage
        ? currentImage.currentSrc || currentImage.src || ''
        : '';

      if (
        !/colissimo/i.test(currentText) &&
        !/colissimo/i.test(currentSrc)
      ) {
        return;
      }

      const icon = row.querySelector('.product__icon');
      if (!icon) return;

      const image = makeImage(
        'lounelle-market-carrier__img lounelle-market-carrier__img--reassurance'
      );

      image.addEventListener(
        'load',
        () => {
          icon.classList.add('lounelle-market-carrier-icon');
          icon.dataset.carrierKey = key;
          icon.replaceChildren(image);

          if (text && /colissimo/i.test(currentText)) {
            text.textContent = currentText.replace(
              /colissimo/gi,
              carrier.name
            );
          }

          row.dataset.lounelleMarketCarrier = key;
        },
        { once: true }
      );
    });

    document.querySelectorAll('.ln-shipping-info__logo').forEach((slot) => {
      if (slot.dataset.lounelleMarketCarrier === key) return;

      const image = makeImage(
        'lounelle-market-carrier__img lounelle-market-carrier__img--shipping'
      );

      image.addEventListener(
        'load',
        () => {
          slot.dataset.carrierKey = key;
          slot.replaceChildren(image);
          slot.dataset.lounelleMarketCarrier = key;
        },
        { once: true }
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', apply);
})();